"use client";

import { Typography } from "../typography";

export type AgentIndicatorProps = {
  agentUuid?: string;
};

/**
 * Displays which AI agent handled the response.
 */
export const AgentIndicator = ({ agentUuid }: AgentIndicatorProps) => (
  <Typography
    size="xs"
    color="neutral"
    className="font-mono opacity-0 transition-opacity hover:opacity-100"
  >
    [Agent: {agentUuid}]
  </Typography>
);
